import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Cautionary } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class CautionaryModule extends VuexModule {
    @Action
    [Cautionary.findPageCautionary](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/cautionary/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Cautionary.saveCautionary](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/cautionary/save`, values,{ headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Cautionary.deleteCautionary](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/cautionary/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Cautionary.uploadCautionaryBanner](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/cautionary/uploadBanner`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Cautionary.uploadArticleImage](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/cautionary/uploadArticleImage`,values,{headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Cautionary.removeArticleImage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/cautionary/removeArticleImage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}